/**
 * @author nihar <nihar.baishya@314ecorp.com>
 * @description Export Statement
 */
import { Button, ButtonProps, Checkbox, Modal, Tooltip } from 'antd';
import { useState } from 'react';
import useExportStatement from 'hooks/mutate/useExportStatement';
import { EXPORT_ENTITY_TYPES } from '@veritable/common/constants';

/**
 * interface for props
 */
export interface IProps extends ButtonProps {
	entityType: StatementEntityType;
	entityId: string;
	entityName: string;
}

const ExportStatement: React.FC<IProps> = ({ entityType, entityId, entityName, disabled, ...restProps }) => {
	const [open, setOpen] = useState(false);
	const [shouldSplitStatement, setShouldSplitStatement] = useState(false);
	const { mutateAsync, isPending } = useExportStatement();

	const isGuarantor = entityType === EXPORT_ENTITY_TYPES.guarantor;
	const openModal = open && isGuarantor && !isPending;

	// function to close modal
	const handleClose = () => {
		setOpen(false);
		setShouldSplitStatement(false);
	};

	// function to handle export statement
	const handleExportStatement = async () => {
		let splitStatement = false;
		if (isGuarantor && shouldSplitStatement) {
			splitStatement = true;
		}
		await mutateAsync(
			{
				statementGenerationRequestModel: { statementType: entityType, statementRequestModel: { id: entityId, splitStatement } },
				entityName,
			},
			{
				onSuccess: handleClose,
			},
		);
	};

	// handle on button click
	const handleOnClick = () => {
		if (isGuarantor) {
			setOpen(true);
		} else {
			handleExportStatement();
		}
	};
	// if guarantor show modal else download statement directly
	return (
		<>
			<Tooltip title={disabled ? "Statement can't be generated because there is no outstanding PR." : ''} placement='bottomRight'>
				<Button color='default' onClick={handleOnClick} disabled={isPending || disabled} {...restProps}>
					{'Download Statement'}
				</Button>
			</Tooltip>
			<Modal
				open={openModal}
				destroyOnHidden
				closable={true}
				onCancel={handleClose}
				maskClosable={false}
				width={600}
				okText={'Download'}
				title={'Download Guarantor Statement'}
				onOk={handleExportStatement}
			>
				<Checkbox checked={shouldSplitStatement} onChange={(e) => setShouldSplitStatement(e.target.checked)}>
					{'Split Statement by Patients (This will download one statement file per patient).'}
				</Checkbox>
			</Modal>
		</>
	);
};

export default ExportStatement;
